export default __webpack_public_path__ + "static/media/breakdown-gray.f80a919d.png";